// apiService.js
import axios from 'axios';
import { configUrl } from "../../config";

function cleanAndAddTotals(obj) {
    // remove $id and normalize total -> totalQuestions
    const cleaned = Object.fromEntries(
        Object.entries(obj)
            .filter(([key]) => key !== "$id") // ignore $id at root
            .map(([key, value]) => [
                key,
                typeof value === "object"
                    ? Object.fromEntries(
                        Object.entries(value)
                            .filter(([k]) => k !== "$id") // ignore $id inside subjects
                            .map(([k, v]) => [k === "total" ? "totalQuestions" : k, v])
                    )
                    : value
            ])
    );

    // calculate totals
    const totals = Object.values(cleaned).reduce(
        (acc, subj) => {
            acc.totalQuestions += subj.totalQuestions ?? 0;
            acc.correct += subj.correct ?? 0;
            acc.incorrect += subj.incorrect ?? 0;
            acc.unattempted += subj.unattempted ?? 0;
            return acc;
        },
        { totalQuestions: 0, correct: 0, incorrect: 0, unattempted: 0 }
    );

    return { ...cleaned, allSubject: totals };
}

function transformSubjectAnalytics(apiResponse) {
    if (!apiResponse?.$values) return [];

    return apiResponse.$values.map(topic => {
        // clean tests (remove $id and normalize names)
        const tests = Object.entries(topic.tests)
            .filter(([k]) => k !== "$id") // ignore $id inside tests
            .reduce((acc, [testId, testData], index) => {
                acc[`Test${index + 1}`] = {
                    TestId: testId,
                    Total: testData.total ?? 0,
                    Correct: testData.correct ?? 0,
                    Incorrect: testData.incorrect ?? 0,
                    Unattempted: testData.unattempted ?? 0,
                    testAttemptedOn: testData.testAttemptedOn,
                    testName: testData.testName ?? 'none',
                };
                return acc;
            }, {});

        return {
            TopicId: topic.topicId,
            TopicName: topic.topicName,
            Tests: tests,
        };
    }).sort((a, b) => a.TopicName.localeCompare(b.TopicName));;
}


export async function UseGetPieCharAnalytics(studentId) {
    try {
        const response = await axios.get(`${configUrl.AssessmentServer}/api/SwotAnalytics/getPieChartAnalytics/${studentId}`);
        console.log("ajcnaojca45", response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export async function UseGetPieChartHeirarchy(studentId) {
    try {
        const response = await axios.get(`${configUrl.AssessmentServer}/api/SwotAnalytics/getStudentsQuestionCoverage/${studentId}`);
        console.log("PieChartheirarcyData", response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export async function UseGetTopicPulseAnalytics(UserId) {
    try {
        const response = await axios.get(`${configUrl.AssessmentServer}/api/SwotAnalytics/GetLast5FSTAnalytics?studentId=${UserId}`);
        console.log("UseGetTopicPulse-", response.data);
        let sampObj = {
            "Physics": { "totalQuestions": 120, "correct": 80, "incorrect": 30, "unattempted": 10 },
            "Chemistry": { "totalQuestions": 110, "correct": 70, "incorrect": 25, "unattempted": 15 },
            "Maths": { "totalQuestions": 100, "correct": 60, "incorrect": 30, "unattempted": 10 },
        }

        return cleanAndAddTotals(response?.data);
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export async function GetLast5FSTSubjectSpecificAnalytics(UserId, subjectname) {
    try {
        const response = await axios.get(`${configUrl.AssessmentServer}/api/SwotAnalytics/GetLast5FSTSubjectSpecificAnalytics?studentId=${UserId}&subjectName=${subjectname}`);
        console.log("GetLast5FST-", response.data);

        return transformSubjectAnalytics(response?.data);
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};